import { Organisation, OrganisationPost } from "callable-data-objects";
import Page from "callable-data-objects/dist/services/Page";
import OrganisationDetails from "Components/Organisation/OrganisationDetails";
import OrganisationListHolder from "Components/Organisation/OrganisationListHolder";
import { useOrganisation } from "Hooks/Endpoints";
import { APIOrganisationProps } from "Providers/types";
import React, { Fragment } from "react";
import { Dimmer, Loader } from "semantic-ui-react";
import OrganisationCreate from "./OrganisationCreate";

const OrganisationView = () => {
  const {
    organisation,
    organisations,
    create,
    loading,
  }: APIOrganisationProps = useOrganisation();
  return (
    <Dimmer.Dimmable dimmed={loading}>
      {renderContent(organisation, organisations, create)}
      <Dimmer inverted active={loading}>
        <Loader />
      </Dimmer>
    </Dimmer.Dimmable>
  );
};

const renderContent = (
  organisation: Organisation | undefined,
  organisations: Page<Organisation> | undefined,
  create: OrganisationPost | undefined
) => {
  if (create) return <OrganisationCreate />;
  else if (!organisation && organisations) return <OrganisationListHolder />;
  else if (organisation) return <OrganisationDetails />;
  else return <Fragment />;
};

export default OrganisationView;
